module.exports = __webpack_public_path__ + "static/media/pressureForecast.cb3f5275.png";